import type { AnalyticsEventProps, ClientAnalyticsProvider } from "@/lib/analytics/types";
import { logger, sanitize } from "@/lib/infra/logger";

export const AnalyticsEvents = {
  ProductViewed: "product_viewed",
  ProductListViewed: "view_item_list",
  ProductClicked: "select_item",
  AddToCart: "add_to_cart",
  RemoveFromCart: "remove_from_cart",
  CheckoutStarted: "begin_checkout",
  PaymentInfoAdded: "add_payment_info",
  OrderPurchased: "purchase",
  UserSignedUp: "user_signed_up",
  DropViewed: "drop_viewed",
} as const;

export type AnalyticsEventName = (typeof AnalyticsEvents)[keyof typeof AnalyticsEvents];

export function trackClientEvent(
  provider: ClientAnalyticsProvider,
  event: string,
  props?: AnalyticsEventProps
): void {
  try {
    const safeProps = props ? (sanitize(props) as AnalyticsEventProps) : undefined;
    provider.track(event, safeProps);
  } catch (error) {
    logger.error("[analytics] client track failed:", error);
  }
}
